import { render, staticRenderFns } from "./message-new-ux.vue?vue&type=template&id=0ae6b8b4&"
import script from "./message-new-ux.vue?vue&type=script&lang=js&"
export * from "./message-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae6b8b4')) {
      api.createRecord('0ae6b8b4', component.options)
    } else {
      api.reload('0ae6b8b4', component.options)
    }
    module.hot.accept("./message-new-ux.vue?vue&type=template&id=0ae6b8b4&", function () {
      api.rerender('0ae6b8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/message-new-ux.vue"
export default component.exports